import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["fr", "en"],
  defaultLocale: "fr",
  // Préfixe la locale par défaut aussi (/fr, /en) - meilleur SEO multilingue
  localePrefix: "always",
});

export type Locale = (typeof routing.locales)[number];
